import script from "./IPDPharmacyInvoice.vue?vue&type=script&setup=true&lang=js"
export * from "./IPDPharmacyInvoice.vue?vue&type=script&setup=true&lang=js"

import "./IPDPharmacyInvoice.vue?vue&type=style&index=0&id=08bcf30d&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08bcf30d"]])

export default __exports__